<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设为客户弹框
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="client-build"
    width="600px"
    title="设为客户"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div v-loading="loading" style="width: 440px; min-height: 300px; margin: 0px auto 20px">
      <div v-if="step == 1" class="flex-center column">
        <div class="iconfont icon-disable text-danger disabled-icon" />
        <div class="font-2x text-bold mt-sm">禁止操作</div>
        <div class="mt-sm">{{ tip }}</div>
      </div>
      <el-form
        v-if="step == 2"
        ref="postForm"
        v-loading="posting"
        class="mt-lg"
        label-position="left"
        label-width="100px"
        :model="formData"
        :rules="rules"
      >
        <el-form-item label="用户">
          <div class="flex align-center">
            <f-user-avatar :src="row.avatar" shape="rounded" />
            <span class="ml-sm">{{ row.nickname }}</span>
          </div>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-radio-group v-model="formData.operate_type" @change="handleChange">
            <el-radio :label="1">新建客户</el-radio>
            <el-radio :label="2">关联客户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户名称" required>
          <template v-if="formData.operate_type == 1 && !formData.company_id">
            <el-input v-model="keyword" placeholder="公司名称" @keydown.enter.native.prevent="handleSearch">
              <div slot="append" role="button" class="pl-lg pr-lg" @click="handleSearch"><i class="el-icon-search"></i></div>
            </el-input>
            <SearchContent ref="searchSelect" :keyword="keyword" tick :height="132" @select="handleSelect" />
          </template>

          <el-tag v-if="formData.operate_type == 1 && formData.company_id" type="blue" closable @close="handleClose">{{ company_name }}</el-tag>

          <el-select v-if="formData.operate_type == 2" v-model="formData.company_id" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in clues" :key="item.company_id" :label="item.company_name" :value="item.company_id">
              <div class="flex align-center">
                <span class="bd">{{ item.company_name }}</span>
                <span class="ft ml-sm text-muted">{{ item.type == 1 ? '客户' : '线索' }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.operate_type == 1 && formData.company_id" label="客户等级" required>
          <PartnerLevelSelector v-model="formData.customer_level" placeholder="" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="flex-center mb">
      <el-button v-if="step == 1" class="extend" @click="dialogShow = false">关闭</el-button>
      <el-button v-if="step == 2" class="extend" @click="dialogShow = false">取消</el-button>
      <el-button v-if="step == 2" class="extend" type="primary" :disabled="(!formData.company_id && formData.operate_type == 2) || ((!formData.customer_level || !formData.company_id) && formData.operate_type == 1)" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { customerPreCheckApi, customerSetApi } from '@/api/up/upMemberApi'

import { leadListApi } from '@/api/prm/prmApi'

export default {
  name: 'ClientBuild',

  components: {
    PartnerLevelSelector: () => import("@/views/prm/components/PartnerLevelSelector.vue"),
    SearchContent: () => import("@/views/prm/components/SearchContent.vue"),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    row: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      loading: false,
      step: 0,
      tip: '',
      keyword: '',
      company_name: '',
      formData: {
        operate_type: 1,
        company_id: null,
        customer_level: null,
      },
      rules: {
        company_id: [{ required: true, message: '请选择客户', trigger: 'blur' }],
        customer_level: [{ required: true, message: '请选择客户等级', trigger: 'blur' }],
      },
      posting: false,
      clues: [],
      list: [],
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    this.fetchCheck() 
  },

  methods: {
    handleChange() {
      this.company_name = ''
      this.formData.company_id = null
      this.formData.customer_level = null
    },
    handleSearch() {
      this.$refs.searchSelect.handleSearch()
    },

    handleSelect(item) {
      this.company_name = item.name
      this.formData.company_id = item.company_id
    },

    handleClose() {
      this.company_name = ''
      this.formData.company_id = null
    },

    fetchCheck() {
      this.loading = true
      customerPreCheckApi({
        memberid: this.row.memberid,
      }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.step = res.data && res.data.status == 1 ? 2 : 1
          this.tip = res.data.message
          if (this.step == 2) this.fetchLead()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    fetchLead() {
      leadListApi().then(res => {
        if (!res.errno) {
          this.clues = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },

    submit() {
      const temp = {
        memberid: this.row.memberid,
        operate_type: this.formData.operate_type,
        company_id: this.formData.company_id,
        customer_level: this.formData.customer_level
      };
      this.$refs.postForm.validate((valid) => {
        if (valid) {
          this.posting = true
          customerSetApi(temp).then((res) => {
            this.posting = false
            if (!res.errno) {
              this.$message.success("客户设置成功！");
              this.$emit("success");
              this.dialogShow = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 30px 20px;
}
/deep/ .el-input-group__append {
  padding: 0 00px;
  background-color: #07c160;
  border: 1px solid #07c160;
  color: #fff;
}
.disabled-icon {
  font-size: 100px;
}
</style>